import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = () => {
    const { isAuthenticated, isLoading } = useAuth();
    if (isLoading) return null;
    return !isAuthenticated ? <Outlet /> : <Navigate to="/over-view" />;
};

export default ProtectedRoute;
